export const FETCH_MUNICIPIOS = "FETCH_MUNICIPIOS";
export const FETCH_MUNICIPIOS_CORRESPONDENCIA =
  "FETCH_MUNICIPIOS_CORRESPONDENCIA";
export const FETCH_UFS = "FETCH_UFS";
export const FETCH_MODALIDADE_PESCA = "FETCH_MODALIDADE_PESCA";
export const FETCH_LOCALIZACAO_PREFERENCIAL_PESCA =
  "FETCH_LOCALIZACAO_PREFERENCIAL_PESCA";
export const FETCH_RENDA_MENSAL = "FETCH_RENDA_MENSAL";
export const FETCH_FAIXA_ETARIA = "FETCH_FAIXA_ETARIA";
export const FETCH_LOCAL_PESCA = "FETCH_LOCAL_PESCA";
export const FETCH_MATERIAL_PESCA = "FETCH_MATERIAL_PESCA";
export const FETCH_TIPO_ISCA = "FETCH_TIPO_ISCA";
export const SEND_SOLICITANTE = "SEND_SOLICITANTE";
export const SEND_INFORMACOES_COMPLEMENTARES =
  "SEND_INFORMACOES_COMPLEMENTARES";
export const REGISTRAR = "REGISTRAR";
export const FETCH_DADOS_CARTEIRA = "FETCH_DADOS_CARTEIRA";
export const CANCELAR = "CANCELAR";
export const SET_ERROR_TELA = "SET_ERROR_TELA";
export const FETCH_NACIONALIDADES = "FETCH_NACIONALIDADES";
export const FETCH_PAISES = "FETCH_PAISES";
export const USUARIO_LOGOUT = "USUARIO_LOGOUT";
export const GET_USUARIO = "GET_USUARIO";
export const SET_SNACKBAR = "SET_SNACKBAR";
